import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Hero from '../components/sections/Hero';
import { useI18n } from '../i18n/I18nContext';
import './Home.css';

const Home: React.FC = () => {
  const { content } = useI18n();
  const home = content.home;

  return (
    <>
      <Hero />
      <section className="home__hub section" aria-labelledby="explore-title">
        <div className="container">
          <div className="home__heading">
            <div>
              <span className="section-label">{home.label}</span>
              <h2 id="explore-title">{home.title}</h2>
            </div>
            <p>{home.intro}</p>
          </div>
          <div className="home__hub-grid">
            {home.sections.map((section, index) => (
              <Link key={section.href} to={section.href} className="home__hub-card">
                <span className="home__hub-number">{String(index + 1).padStart(2, '0')}</span>
                <div><h3>{section.title}</h3><p>{section.description}</p></div>
                <ArrowRight size={17} className="home__hub-arrow" />
              </Link>
            ))}
          </div>
          <div className="home__cta">
            <div><h2>{home.ctaTitle}</h2><p>{home.ctaText}</p></div>
            <Link to="/request" className="btn btn-primary">{home.cta}</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
